import React from "react"
import { FullWidthImageSection, Button, Hyperlink } from "components"
import MyMazdaRecallNotification from "blocks/mymazda/recall-notification"
import MyMazdaAccountPassword from "blocks/mymazda/account-password"
import MyMazdaResetPassword from "blocks/mymazda/reset-password"
import HeadingSectionBlock from "blocks/heading-section"
import TriggeredOverlay from "containers/triggered-overlay"
import { withDynamicComponents } from "higher-order-components"

const FullWidthImageSectionBlock = props => <FullWidthImageSection {...props} />

FullWidthImageSectionBlock.displayName = "FullWidthImageSection" // @CMS-CHANGE FullWidthImageSection => FullWidthImageSectionBlock

export default withDynamicComponents({
  componentWhitelist: [
    Button,
    TriggeredOverlay,
    MyMazdaRecallNotification,
    MyMazdaAccountPassword,
    MyMazdaResetPassword,
    Hyperlink,
    HeadingSectionBlock
  ]
})(FullWidthImageSectionBlock)



// WEBPACK FOOTER //
// ./src/blocks/full-width-image-section/index.jsx